import axios from "axios";
import Swal from "sweetalert2";

export const Request = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

Request.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("token");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

Request.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const backendMessage = error.response?.data?.message || "Something went wrong";
    const statusCode = error.response?.status;

    if (statusCode === 401 && backendMessage === "Invalid token") {
      localStorage.removeItem("token");

      await Swal.fire({
        icon: "warning",
        title: "Session Expired",
        text: "Your session has expired. Please login again.",
        confirmButtonColor: "#b1a249",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        window.location.href = "/login";
      });

      return Promise.reject(error);
    }

    if (statusCode === 401) {
      localStorage.removeItem("token");
      await Swal.fire({
        icon: "warning",
        title: "Session Expired",
        text: "Your session has expired. Please login again.",
        confirmButtonColor: "#b1a249",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        window.location.href = "/login";
      });

      return Promise.reject(error);
    }

    console.error(`API Error (status: ${statusCode}):`, error.response?.data || error);
    return Promise.reject(error);
  }
);

const useHtpp = () => {
  function configureHeaders() {
  }

  const configureInterceptors = () => {
  };

  return { configureHeaders, configureInterceptors };
};

export default useHtpp;
